import { exporter } from '@sde/widgets-core/src/tools/exporter';
import { Widget } from './widget';
import { reducers } from './state/modules';

export const PayerSelectDrawer = exporter(Widget, { reducers });
